const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1807"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 1699",
    style: {
      fill: "rgba(26,217,71,.11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 35.5c-4.674 0-9.069-1.82-12.374-5.126A17.385 17.385 0 0 1 .5 18c0-4.674 1.82-9.069 5.126-12.374A17.385 17.385 0 0 1 18 .5c4.674 0 9.07 1.82 12.374 5.126A17.385 17.385 0 0 1 35.5 18c0 4.674-1.82 9.07-5.126 12.374A17.385 17.385 0 0 1 18 35.5z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 1C13.46 1 9.19 2.768 5.98 5.98A16.889 16.889 0 0 0 1 18c0 4.54 1.768 8.81 4.98 12.02C9.19 33.233 13.46 35 18 35c4.54 0 8.81-1.768 12.02-4.98C33.233 26.81 35 22.54 35 18c0-4.54-1.768-8.81-4.98-12.02A16.889 16.889 0 0 0 18 1m0-1c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0z",
    style: {
      fill: "#1ad947",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-check",
    d: "M21.923 9 10.976 19.947 6 14.971",
    transform: "translate(4.5 3.5)",
    style: {
      fill: "none",
      stroke: "#1ad947",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.4px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.2fd2f50d1316c0f00fcfb0b803ec0c97.svg";
export { ForwardRef as ReactComponent };